import db from '../db';

class Department {
  static getInstance(){
    return new Department();
  }

  async index() {
    try {
      return await db.departments.toArray();
    } catch (error) {
      throw error
    }
  };

  async create(department) {
    try {
      let create_id = await db.departments.add({...department});
      return db.departments.get({id: create_id});
    } catch (error) {
      throw error
    }
  };

  async update(department) {
    try {
      await db.departments.put({...department});
    } catch (error) {
      throw error
    }
  };

  async delete(department) {
    try {
      await db.departments.delete(department.id);
    } catch (error) {
      throw error
    }
  };
}

export default Department;